import Vue from 'vue'

const stringUpper = Vue.filter('stringUpper', function (string) {
    return string ? string.toUpperCase() : ''
})

export default { stringUpper }